<label>
  <!-- tell prettier to not insert whitespaces -->
  <!-- display: inline -->
  <div class="form-field__label form-field__summary-label">{{
    field?.label | translateInline
  }}</div>

  <div class="form-field__summary form-field__radio-group-summary">
    {{ content$ | async | translateInline }}
  </div>
</label>
